import React from 'react';
import { Mail, Phone, Instagram, Facebook, Youtube, Music2 } from 'lucide-react';

const Footer = ({ contact }) => {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-column">
            <h3 className="heading-3" style={{ marginBottom: '24px' }}>Luka Nozza</h3>
            <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
              Live music for an unforgettable night. Creating memorable experiences through exceptional performances.
            </p>
          </div>

          <div className="footer-column">
            <h4 className="body-regular" style={{ fontWeight: '700', marginBottom: '16px' }}>Quick Links</h4>
            <nav className="footer-nav">
              <a href="#about" className="footer-link">About</a>
              <a href="#shows" className="footer-link">Shows</a>
              <a href="#testimonials" className="footer-link">Testimonials</a>
              <a href="#newsletter" className="footer-link">Contact</a>
            </nav>
          </div>

          <div className="footer-column">
            <h4 className="body-regular" style={{ fontWeight: '700', marginBottom: '16px' }}>Contact</h4>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <Mail size={16} />
                <span className="body-small">{contact.email}</span>
              </div>
              <div className="footer-contact-item">
                <Phone size={16} />
                <span className="body-small">{contact.phone}</span>
              </div>
            </div>
          </div>

          <div className="footer-column">
            <h4 className="body-regular" style={{ fontWeight: '700', marginBottom: '16px' }}>Follow</h4>
            <div className="footer-social">
              <a href={contact.socialMedia.instagram} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href={contact.socialMedia.spotify} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Spotify">
                <Music2 size={20} />
              </a>
              {contact.socialMedia.facebook !== "#" && (
                <a href={contact.socialMedia.facebook} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                  <Facebook size={20} />
                </a>
              )}
              <a href={contact.socialMedia.youtube} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="YouTube Showreel">
                <Youtube size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
            © {new Date().getFullYear()} Luka Nozza. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;